import axios from '@/common/axios'

export const updateProfile = (payload) => axios.patch('/api/profile/account', { user: payload })
export const updatePassword = (payload) => axios.patch('/api/profile/password', { user: payload })
export const fetchAccountPageMeta = () => axios.get('/api/profile/account/page_meta')
